export enum odxVariants {
    primary = 'primary',
    secondary = 'secondary',
    ghost = 'ghost',
    highlight = 'highlight',
    success = 'success',
    danger = 'danger',
    confirmation = 'confirmation',
    warning = 'warning',
    transparent = 'transparent',

}

export enum odxIconSets {
    core = 'core',
    uibLegacy = 'uib-legacy',
    medical = 'medical',
    safety = 'safety',
}
